import React from 'react';
import { Box, FormControl, Select, MenuItem, Typography } from '@mui/material';

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
const DEFAULT_PAGE_SIZE = 25;

/**
 * PageSizeSelector - Dropdown to select results per page
 *
 * @param {number} value - Current page size
 * @param {function} onChange - Callback when page size changes
 * @param {string} label - Optional label text (default: "per page")
 */
export default function PageSizeSelector({ value, onChange, label = 'per page' }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl size="small" sx={{ minWidth: 70 }}>
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Results per page"
          inputProps={{ 'aria-label': 'Results per page' }}
          sx={{
            '& .MuiSelect-select': { py: 0.5 },
            fontSize: '0.875rem'
          }}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

export { PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE };
